import * as React from 'react';
import { IIntegrateAdOptions } from '../../offers/helpers';
import { IServicePlaceWidgetMarkup } from '../../../../filters/api';
import { IUserGADataLayerData } from '../../../../common/state';
import { trackServicePlaceClick } from './tracking';

export interface IBannerServicePlaceInternalProps {
  soprApi?: string;
  currentResultPageNumber?: number;
  deviceType?: string;
  queryString?: string;
  observerKey?: string | number;
  userGADataLayerData?: IUserGADataLayerData | null;
  servicePlaceWidgetMarkups: IServicePlaceWidgetMarkup[];
  options: IIntegrateAdOptions;
  position: number;
  containerRef?: React.RefObject<HTMLDivElement>;
}

export class BannerServicePlaceInternal extends React.Component<IBannerServicePlaceInternalProps> {
  public componentDidMount(): void {
    if (typeof document !== 'undefined' && document.querySelector) {
      const widgetJs = '//cdn.cian.site/finance/serp-service-place/widget.js';
      if (!document.querySelector(`script[src="${widgetJs}"]`)) {
        const script = document.createElement('script');
        script.src = widgetJs;
        script.async = true;
        document.body.appendChild(script);
      }
    }
  }

  public handleServicePlaceClick = (
    label: 'servisnoe_mesto_oldstyle_3_show' | 'servisnoe_mesto_oldstyle_33_show' | 'servisnoe_mesto_oldstyle_63_show',
  ) => {
    trackServicePlaceClick(label);
  };

  public render() {
    const { position, servicePlaceWidgetMarkups, containerRef } = this.props;

    if (servicePlaceWidgetMarkups) {
      switch (position) {
        case 2:
          if (servicePlaceWidgetMarkups[0]) {
            return (
              <div
                ref={containerRef}
                onClick={() => this.handleServicePlaceClick('servisnoe_mesto_oldstyle_3_show')}
                dangerouslySetInnerHTML={{ __html: servicePlaceWidgetMarkups[0].markup }}
              ></div>
            );
          }
          break;
        case 32:
          if (servicePlaceWidgetMarkups[1]) {
            return (
              <div
                ref={containerRef}
                onClick={() => this.handleServicePlaceClick('servisnoe_mesto_oldstyle_33_show')}
                dangerouslySetInnerHTML={{ __html: servicePlaceWidgetMarkups[1].markup }}
              ></div>
            );
          }
          break;
        case 62:
          if (servicePlaceWidgetMarkups[2]) {
            return (
              <div
                ref={containerRef}
                onClick={() => this.handleServicePlaceClick('servisnoe_mesto_oldstyle_63_show')}
                dangerouslySetInnerHTML={{ __html: servicePlaceWidgetMarkups[2].markup }}
              ></div>
            );
          }
      }
    }

    return null;
  }
}
